export default __webpack_public_path__ + "static/media/relax.7537bc1d.svg";